import { Image } from 'antd'
import styled from 'styled-components'

export const StyledIcon = styled(Image)`
  position: relative;
  top: 3px;
  padding-left: 3px;
  height: 32px;
`
